<template>
  <main class="panels">
    <b-container v-if="currentAnalyse">
      <b-row class="analysis-head">
        <b-col cols="4" class="pl-0">
          <h1 class="text-overflow-ellipsis">
            {{ currentAnalyse.name }}
          </h1>
        </b-col>
        <b-col cols="8" class="text-right pr-0">
          <!--<router-link :to="{ name: 'ExploreAnalysisIndex' }" class="border-0">
            <i class="fa fa-angle-left" /> Back to analyses
          </router-link>-->
          <!--<b-link
            class="btn btn-sm btn-outline-secondary"
            @click="dimReduction"
          >
            <i class="fas fa-border-none"></i> Dimension Reduction
          </b-link>-->
          <b-dropdown size="sm" variant="outline-secondary" class="ml-2">
            <template slot="button-content">
              <i class="fa fa-download mr-1" /> Export
            </template>
            <b-dropdown-item @click="downloadSvg">
              Export as SVG
            </b-dropdown-item>
            <b-dropdown-item @click="downloadPng">
              Export as PNG
            </b-dropdown-item>
            <b-dropdown-item @click="downloadPpt">
              Export as PPT
            </b-dropdown-item>
            <b-dropdown-item @click="downloadXls">
              Export as XLS
            </b-dropdown-item>
          </b-dropdown>

          <b-link
            class="ml-2 btn btn-sm btn-outline-secondary"
            @click="quickEdit"
          >
            <i class="fa fa-pencil-alt" /> Quick Edit
          </b-link>
          <router-link
            :to="{
              name: 'ExploreAnalysisEdit',
              params: { id: this.$route.params.id },
            }"
            class="ml-2 btn btn-sm btn-outline-secondary"
          >
            <i class="fa fa-pencil-alt" /> Edit analysis
          </router-link>
          <b-link
            class="ml-2 btn btn-sm btn-outline-secondary"
            @click="confirmDelete"
          >
            <i class="fa fa-trash" /> Delete analysis
          </b-link>
        </b-col>
      </b-row>

      <b-row>
        <b-col ref="anlview" class="anlysis-view">
          <BarChartView
            v-if="currentAnalyse.config.type === 'barchart'"
            ref="anl"
            :analyse="currentAnalyse"
            :settings="bChartSettings"
            :responsive="false"
            @setDefault="setDefaultSettings"
          />
          <ColumnChartView
            v-if="currentAnalyse.config.type === 'columnchart'"
            ref="anl"
            :analyse="currentAnalyse"
            :settings="cChartSettings"
            :responsive="false"
            @setDefault="setDefaultSettings"
          />
          <DocUniverseView
            v-if="currentAnalyse.config.type === 'docuniverse'"
            ref="anl"
            :show-title="true"
            :show-controls="true"
            :analyse="currentAnalyse"
            :responsive="false"
            @setDefault="setDefaultSettings"
          />
          <HeatmapView
            v-if="currentAnalyse.config.type === 'heatmap'"
            ref="anl"
            :analyse="currentAnalyse"
            :settings="heatmapSettings"
            :responsive="false"
            @setDefault="setDefaultSettings"
          />
          <LineChartView
            v-if="currentAnalyse.config.type === 'linechart'"
            ref="anl"
            :analyse="currentAnalyse"
            :settings="lChartSettings"
            :responsive="false"
            @setDefault="setDefaultSettings"
          />
          <OneDHeatmap
            v-if="currentAnalyse.config.type === 'onedheatmap'"
            ref="anl"
            :analyse="currentAnalyse"
            :settings="oneDSettings"
            :responsive="false"
            @setDefault="setDefaultSettings"
          />
          <ScatterPlotView
            v-if="currentAnalyse.config.type === 'scatterplot'"
            ref="anl"
            :analyse="currentAnalyse"
            :settings="sPlotSettings"
            :responsive="false"
            @setDefault="setDefaultSettings"
          />
          <WorldmapView
            v-if="currentAnalyse.config.type === 'worldmap'"
            ref="anl"
            :analyse="currentAnalyse"
            :settings="worldmapSettings"
            :responsive="true"
            @setDefault="setDefaultSettings"
          />
          <DimredPlotView
            v-if="currentAnalyse.config.type === 'clustermap'"
            ref="anl"
            :analyse="currentAnalyse"
            :responsive="false"
          />
        </b-col>
      </b-row>
      <div id="hoverDiv"></div>
    </b-container>
    <panelOptions
      v-if="showOptionsPanel"
      :element="activeElement"
    ></panelOptions>

    <div
      class="container-fluid panel-top"
      :class="{
        opened: showTopPanel,
        //leftopened: showLeftSidebar,
        //rightopened: showExploreSidebar,
        //leftrightopened: showLeftSidebar && showExploreSidebar
      }"
    >
      <b-row>
        <b-col
          ><PanelTop
            :settings-panel="'AnalysisSettings'"
            :settings="quickSettings"
            @updateSettings="updateSettings"
            @redrawAnalysis="redrawAnalysis"
          ></PanelTop
        ></b-col>
      </b-row>
      <b-row class="panel-switch">
        <b-col class="d-flex justify-content-center">
          <b-btn
            class="btn-top-panel"
            variant="outline"
            @click="toggleTopPanel"
          >
            <i class="fa fa-caret-down" />
          </b-btn>
        </b-col>
      </b-row>
    </div>

    <div class="left-sidebar-toggle" :class="{ opened: showLeftSidebar }">
      <b-btn variant="outline-secondary" @click="toggleLeftSidebar">
        <i class="fa fa-redo"></i>
        <span class="ml-2">Analysis</span>
      </b-btn>
    </div>
    <div class="panel-left" :class="{ opened: showLeftSidebar }">
      <h2 class="mb-3">Select Analysis</h2>
      <b-row
        v-for="analyse in analyses"
        :key="analyse._id"
        align-h="between"
        class="analysis insidebar"
        no-gutters
      >
        <b-col class="analysis-col-left">
          <router-link
            :to="{ name: 'ExploreAnalysisView', params: { id: analyse._id } }"
          >
            <h1
              :class="{
                active: currentAnalyse && analyse._id === currentAnalyse._id,
              }"
            >
              {{ analyse.name }}
            </h1>
          </router-link>
          <p>{{ analyse.description }}</p>
          <p class="small">
            {{ analyse.config.type | ucFirst }}<br />
            {{ analyse.config.query.startyear }} &ndash;
            {{ analyse.config.query.recentyear }} &ndash;
            {{ analyse.config.query.stopyear }}
          </p>
        </b-col>
      </b-row>
    </div>

    <div
      class="container-fluid panel-bottom"
      :class="{
        opened: showDocumentsPanel,
        //leftopened: showLeftSidebar,
        //rightopened: showExploreSidebar,
        //leftrightopened: showLeftSidebar && showExploreSidebar,
        expanded: showDocumentsPanel && panelExpanded === 'expanded',
      }"
    >
      <b-row class="panel-head pt-2 pb-2">
        <b-col cols="7" class="d-flex align-items-center">
          <p class="text-overflow-ellipsis">
            {{ documentsCount }} documents
            <span class="text-muted">
              filter: {{ filterFocused ? filterFocused.name : "none" }},
              selection:
              {{
                activeElement
                  ? Array.isArray(activeElement)
                    ? activeElement[0].name
                    : activeElement.name
                  : "none"
              }}
            </span>
          </p>
        </b-col>
        <b-col class="d-flex justify-content-end align-items-center">
          <b-btn
            v-if="showDocumentsPanel"
            :variant="panelExpanded ? 'outline-secondary' : 'outline-secondary'"
            class="mr-1"
            @click="resizeDocumentsPanel"
          >
            <i class="fa fa-expand" />
          </b-btn>
          <b-btn
            v-if="showDocumentsPanel"
            variant="outline-secondary"
            class="mr-1"
            @click="clearDocFilter"
          >
            <i class="fa fa-undo" />
          </b-btn>
          <xlsx-workbook
            v-if="exportReady"
            class="btn mr-1 btn-outline-secondary p-0 d-flex"
          >
            <xlsx-sheet :collection="exportData" :sheet-name="'sheet name'" />
            <xlsx-download>
              <b-btn variant="white"><i class="fa fa-download" /></b-btn>
            </xlsx-download>
          </xlsx-workbook>
          <b-button
            v-else
            variant="outline-secondary"
            class="mr-1"
            @click="exportDocs"
          >
            <b-spinner v-if="docsLoading" small type="grow"></b-spinner>
            {{ docsLoading ? "Downloading Docs" : "Export Docs" }}
          </b-button>
          <b-form-select
            v-model="selectedCollection"
            class="custom-select custom-select-collections mr-1 mb-0"
            :options="options"
            @change="getCollectionDocs"
          ></b-form-select>
          <b-btn variant="primary" @click="toggleDocumentsPanel">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-double-down"
              viewBox="0 0 16 16"
              v-if="showDocumentsPanel"
            >
              <path
                fill-rule="evenodd"
                d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
              <path
                fill-rule="evenodd"
                d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-double-up"
              viewBox="0 0 16 16"
              v-else
            >
              <path
                fill-rule="evenodd"
                d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z"
              />
              <path
                fill-rule="evenodd"
                d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
              />
            </svg>
            <span class="ml-2">Document panel</span>
          </b-btn>
        </b-col>
      </b-row>
      <b-row class="panel-body">
        <b-col>
          <PanelBottom 
            :selection="activeElement" 
            ref="docPanel">
          </PanelBottom>
        </b-col>
      </b-row>
    </div>
    <chatbot @toggleDocumentsPanel="toggleDocumentsPanel" v-if="chatbotState" />
  </main>
</template>

<script>
import _ from "lodash";
import { XlsxDownload, XlsxSheet, XlsxWorkbook } from "vue-xlsx";
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import PanelBottom from "../Shared/PanelBottom";
import PanelOptions from "../Shared/PanelOptions";
import PanelTop from "../Shared/PanelTop";
import BarChartView from "../Visualizations/BarChartView";
import ColumnChartView from "../Visualizations/ColumnChartView";
import DocUniverseView from "../Visualizations/DocUniverseView";
import HeatmapView from "../Visualizations/HeatmapView";
import LineChartView from "../Visualizations/LineChartView";
import OneDHeatmap from "../Visualizations/OneDHeatmapView";
import ScatterPlotView from "../Visualizations/ScatterPlotView";
import DimredPlotView from "../Visualizations/DimredPlotView";
import {
  downloadPpt,
  downloadSvg,
  downloadSvg2Png,
  downloadXls,
  dataForDimRed,
  calculateSR
} from "../Visualizations/shared/utilities";
import WorldmapView from "../Visualizations/WorldmapView";
import BarChartSettings from "./DefaultControlSettings/barChartSettings";
import ColumnChartSettings from "./DefaultControlSettings/columnChartSettings";
import HeatmapSettings from "./DefaultControlSettings/heatmapSettings";
import LineChartSettings from "./DefaultControlSettings/lineChartSettings";
import OneDHeatmapSettings from "./DefaultControlSettings/oneDHeatmapSettings";
import ScatterPlotSettings from "./DefaultControlSettings/scatterPlotSettings";
import WorldmapSettings from "./DefaultControlSettings/worldmapSettings";
import Chatbot from '../Chatbot/Chatbot.vue';

export default {
  name: "ExploreAnalysisView",
  components: {
    BarChartView,
    ColumnChartView,
    DocUniverseView,
    HeatmapView,
    LineChartView,
    OneDHeatmap,
    ScatterPlotView,
    DimredPlotView,
    WorldmapView,
    PanelTop,
    PanelBottom,
    PanelOptions,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    dataForDimRed,
    calculateSR,
    Chatbot
  },
  data() {
    return {
      activeElement: null,
      currentAnalyse: null,
      showDocumentWebkey: null,
      showExploreSidebar: false,
      showLeftSidebar: false,
      showTopPanel: false,
      showDocumentsPanel: false,
      showOptionsPanel: false,
      bChartSettings: null,
      heatmapSettings: null,
      lChartSettings: null,
      oneDSettings: null,
      cChartSettings: null,
      worldmapSettings: null,
      sPlotSettings: null,
      quickSettings: {
        color: null,
        colorOptions: null,
        sortZ: null,
        sortZOptions: null,
        sizeLimit: null,
        sizeRange: null,
        recencyLimit: null,
        recencyRange: null,
      },
      bChartDefaults: null,
      lChartDefaults: null,
      oneDDefaults: null,
      heatmapDefaults: null,
      cChartDefaults: null,
      worldmapDefaults: null,
      sPlotDefaults: null,
      options: [{ value: null, text: "Select Collection" }],
      selectedCollection: null,
      exportReady: false,
      docsLoading: false,
      exportData: []
    };
  },
  computed: {
    ...mapGetters(["analyseById"]),
    ...mapState({
      apiId: (state) => state.api.apiId,
      analyses: (state) => state.analyse.analyses,
      documents: (state) => state.document.documents,
      documentsExport: (state) => state.document.documentsExport,
      documentsCount: (state) => state.document.documentsCount,
      filterFocused: (state) => state.filter.filterFocused,
      panelExpanded: (state) => state.document.documentsPanelState,
      collections: (state) => state.collection.collections,
      chatbotState: (state) => state.chatbot.chatbotState
    }),
    focused() {
      return this.filterFocused;
    },
  },
  watch: {
    documents() {
      this.exportReady = false;
      this.docsLoading = false;
    },
    collections() {
      this.setCollections();
      this.exportReady = false;
      this.docsLoading = false;
    },
    selectedCollection() {
      this.exportReady = false;
      this.docsLoading = false;
    },
    focused() {
      this.loadAnalyses().then(() => {
        this.currentAnalyse = this.analyseById({ id: this.$route.params.id });
        document.title += " – " + this.currentAnalyse.name;
        if (!this.currentAnalyse) {
          alert("Analyse not found");
        }
      });
    },
  },
  mounted() {
    this.setCollections();
    this.loadAnalyses().then(() => {
      this.currentAnalyse = this.analyseById({ id: this.$route.params.id });
      document.title += " – " + this.currentAnalyse.name;
      if (!this.currentAnalyse) {
        alert("Analyse not found");
      }
    });
    EventBus.$on("showOptions", (element) => {
      //console.log(element);
      if (element !== null) {
        if (Array.isArray(element)) {
          if (element.length !== 0) {
            this.activeElement = element;
            this.showOptionsPanel = true;
          } else {
            this.showOptionsPanel = false;
            this.activeElement = null;
          }
        } else {
          this.activeElement = [element];
          this.showOptionsPanel = true;
        }
      } else {
        this.showOptionsPanel = false;
        this.activeElement = null;
      }
    });
    EventBus.$on("showDocumentsPanel", () => {
      if (!this.showDocumentsPanel) {
        this.toggleDocumentsPanel();
      }
    });
    EventBus.$on("toggleTopPanel", () => {
      this.toggleTopPanel();
    });
  },
  beforeDestroy() {
    this.clearSelections();
  },
  methods: {
    ...mapActions([
      "loadAnalyses",
      "deleteAnalyse",
      "saveActiveVisual",
      "saveSubsetFilter",
      "saveFilterQuery",
      "saveDocPanelState",
      "loadCollectionDocs",
      "loadDocuments",
      "exportDocuments"
    ]),
    setCollections() {
      this.options = [{ value: null, text: "Select Collection" }];
      _.each(this.collections, (coll) => {
        this.options.push({
          value: coll._id,
          text: coll.name,
        });
      });
    },
    getCollectionDocs() {
      this.loadCollectionDocs(this.selectedCollection);
    },
    setDefaultSettings(defaults) {
      this.quickSettings = defaults;
      switch (defaults.view) {
        case "barchart":
          this.bChartDefaults = defaults;
          this.quickSettings.controls = BarChartSettings;
          break;
        case "columnchart":
          this.cChartDefaults = defaults;
          this.quickSettings.controls = ColumnChartSettings;
          break;
        case "heatmap":
          this.heatmapDefaults = defaults;
          this.quickSettings.controls = HeatmapSettings;
          break;
        case "linechart":
          this.lChartDefaults = defaults;
          this.quickSettings.controls = LineChartSettings;
          break;
        case "onedheatmap":
          this.oneDDefaults = defaults;
          this.quickSettings.controls = OneDHeatmapSettings;
          break;
        case "scatterplot":
          this.sPlotDefaults = defaults;
          this.quickSettings.controls = ScatterPlotSettings;
          break;
        case "worldmap":
          this.worldmapDefaults = defaults;
          this.quickSettings.controls = WorldmapSettings;
          break;
      }
    },
    updateSettings(settings) {
      if (settings.view === "barchart") {
        this.bChartSettings = this.bChartDefaults = settings;
      }
      if (settings.view === "columnchart") {
        this.cChartSettings = this.cChartDefaults = settings;
      }
      if (settings.view === "heatmap") {
        this.heatmapSettings = this.heatmapDefaults = settings;
      }
      if (settings.view === "linechart") {
        this.lChartSettings = this.lChartDefaults = settings;
      }
      if (settings.view === "onedheatmap") {
        this.oneDSettings = this.oneDDefaults = settings;
      }
      if (settings.view === "scatterplot") {
        this.sPlotSettings = this.sPlotDefaults = settings;
      }
      if (settings.view === "worldmap") {
        this.worldmapSettings = this.worldmapDefaults = settings;
      }
    },
    redrawAnalysis() {
      this.loadAnalyses().then(() => {
        this.currentAnalyse = this.analyseById({
          id: parseInt(this.$route.params.id),
        });
        if (!this.currentAnalyse) {
          alert("Analyse not found");
        }
      });
    },
    confirmDelete() {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to delete analysis “${this.currentAnalyse.name}”?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (value) {
            this.deleteAnalyse({
              analyseId: this.currentAnalyse._id,
            }).then(() => {
              this.$router.push({ name: "ExploreAnalysisIndex" });
              this.$toasted.show("Analysis deleted");
            });
          }
        });
    },
    downloadSvg() {
      let svg = this.$refs.anlview.querySelector("svg");
      downloadSvg(svg);
    },
    downloadPng() {
      let svg = this.$refs.anlview.querySelector("svg");
      downloadSvg2Png(svg);
    },
    downloadPpt() {
      let svg = this.$refs.anlview.querySelector("svg");
      downloadPpt(svg);
    },
    downloadXls() {
      let crainData = this.$refs.anl.visualization.control.crainData;
      downloadXls(crainData);
    },
    quickEdit() {
      this.toggleTopPanel();
    },
    toggleLeftSidebar() {
      this.showLeftSidebar = !this.showLeftSidebar;
    },
    toggleTopPanel() {
      this.showTopPanel = !this.showTopPanel;
    },
    toggleDocumentsPanel() {
      this.showDocumentsPanel = !this.showDocumentsPanel;
    },
    resizeDocumentsPanel() {
      this.panelExpanded === "default"
        ? this.saveDocPanelState("expanded")
        : this.saveDocPanelState("default");
    },
    clearDocFilter() {
      this.saveFilterQuery({ query: [] });
    },
    clearSelections() {
      this.saveFilterQuery({ query: [] });
      this.saveSubsetFilter([null]);
      this.saveActiveVisual([null]);
    },
    exportDocs() {
      this.docsLoading = !this.docsLoading;
      if (this.docsLoading) {
        /*this.loadDocuments({
          which: "global",
          page: 1,
          pageSize: this.documents.length,
          sortOn: "pubdate",
          sortAsc: false,
        }).then(() => {*/
        this.exportDocuments({ docs: _.map(this.documents, "webkey"), model: this.apiId }).then(() => {
          this.formatExportDocuments();
          this.exportReady = true;
        });
        //});
      } else {
        this.exportReady = false;
      }
    },
    getMetaValues(values) {
      const v = values.map((meta) => meta[0]);
      let metaVals = [];
      v.forEach((val) => {
        metaVals.push(val.name);
      });
      return metaVals.join(" | ");
    },
    async formatExportDocuments() {
      this.exportData = [];
      this.documentsExport.forEach((d) => {
        let text = {};
        let tempObj = {};
        d.text.forEach((t) => {
          tempObj[t.name] = t.text;
          text = { ...text, ...tempObj };
        });
        Object.entries(d.meta).forEach((entry) => {
          const [key, value] = entry;
          tempObj[key.split("_")[1]] = this.getMetaValues(value);
          text = { ...text, ...tempObj };
        });
        this.exportData.push(text);
      });
    },
    resetCollection() {
      this.selectedCollection = null;
    },
  },
};
</script>
